/**
 * @generated SignedSource<<2be9a504e61844bca2250b70965f1846>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleFocusScreenSummary_contentSummary$data = {
  readonly dailyTeamSchedule: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleFocusScreenColumn_teamSchedule">;
  };
  readonly monthlyTeamSchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleFocusScreenColumn_teamSchedule">;
  };
  readonly weeklyTeamSchedule: {
    readonly events: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleFocusScreenColumn_teamSchedule">;
  };
  readonly " $fragmentType": "TeamScheduleFocusScreenSummary_contentSummary";
};
export type TeamScheduleFocusScreenSummary_contentSummary$key = {
  readonly " $data"?: TeamScheduleFocusScreenSummary_contentSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleFocusScreenSummary_contentSummary">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamScheduleFocusScreenColumn_teamSchedule"
},
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "includeInlineRoutines",
        "value": true
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  },
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleFocusScreenSummary_contentSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "dailyTeamSchedule",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "weeklyTeamSchedule",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "monthlyTeamSchedule",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "WidgetTeamScheduleContentSummary",
  "abstractKey": null
};
})();

(node as any).hash = "00232c54de9485ea6c343d02ff76ca9a";

export default node;
